<template>
  <div class="testbuyer-page">
    <TestBuyerTopbar />
    <div class="testbuyer-page-main">
      <router-view />
    </div>
  </div>
</template>

<script>
import TestBuyerTopbar from '../layout/components/TestBuyerTopbar.vue'
export default {
  components: {
    TestBuyerTopbar
  }
}
</script>